export default {
  BODY_DRAGGABLE_CLASS: 'react-draggable-transparent-selection',
  SLIDER_HANDLE_SELECTOR: '.rc-slider-handle',
};
